import {Skeleton} from "@mui/material";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {sharedSelectors, updateTemplateDetails} from "@/redux/slices/admin/shared";
import {useEffect} from "react";
import {TemplatesApi, useGetTemplateByIdQuery} from "@/redux/rtk/admin/templates";
import {TEMPLATE_PROPS} from "@/app/admin/templates/page";

const TemplateName = ({uid}: { uid: number }) => {
    const {data, isLoading} = useGetTemplateByIdQuery(uid);
    const dispatch= useDispatch();
    const recordDetails = useSelector(state => sharedSelectors.getTemplateDetails(state), shallowEqual);

    useEffect(() => {
        if(data?.data?.recordDetails?.[0]) {
            dispatch(updateTemplateDetails(data.data.recordDetails[0] as TEMPLATE_PROPS))
        }
    }, [data])

    useEffect(() => {
        return () => {
            dispatch(TemplatesApi.util.resetApiState());
        };
    }, [dispatch]);

    return <>
        {isLoading ? <Skeleton sx={{width: "5rem"}} variant="text"/> :
            !recordDetails ? null : `${recordDetails.name}`}
    </>
}

export default TemplateName;